import _ from 'underscore';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { toHex, contrastColor } from '@bingads-webui-universal/primitive-utilities';

import template from './template.pug';

export class LabelsPopupContentView extends DeterministicView {
/**
 *
 * @param {object} options the option.
 * @param {object} target the target that the popover will show for.
 * @param {Object} position the position that popover view will show besides the target.
 * @param {String} containerClassName the class name for popover view.
 *
 * @return {Void} void
 */
  initialize({
    labels = [],
    i18n,
    entityType,
    entityName,
    isMCCLabelEnabled,
  }) {
    this.options = {
      labels,
      i18n,
      entityType,
      entityName,
      isMCCLabelEnabled,
    };

    super.initialize(this.options);
  }

  getAction(event) {
    const action = {
      name: event.currentTarget.attributes['data-action'].value,
    };
    return action;
  }

  onAction(event) {
    this.trigger('remove', this.getAction(event));
  }

  onLabelCellItemClicked(event) {
    const action = {
      event,
      ...this.getAction(event),
    };
    this.trigger('remove', action);
  }

  tooltip(i18n, label) {
    return _.isEmpty(label.Description) ?
      label.Name :
      i18n.getString('label_tooltip_format').replace('{0}', label.Name).replace('{1}', label.Description);
  }

  backgroundColor(label) {
    return `#${toHex(label.ColorCode)}`;
  }

  textColor(label) {
    return `#${toHex(contrastColor(label.ColorCode))}`;
  }

  get template() {
    return () => template(_.extendOwn({
      backgroundColor: this.backgroundColor,
      textColor: this.textColor,
      tooltip: this.tooltip,
    }, this.options));
  }

  events() {
    return {
      'click .action': this.onAction,
      'click .labels-cell-item': this.onLabelCellItemClicked,
    };
  }
}

